import { ReactComponent as ThirdPartyAxisSIP } from '../../assets/ThirdPartyAxisSIP.svg';
import { DEVICE_TYPE } from '../../config/devices';
import { getTypeFromDeviceType } from '../../helpers/devices';

const UNKNOWN_DEVICE = '0-0-0-0';

export function getIcon(deviceType: string, type?: string) {
  if (deviceType) {
    const model = getModelFromDeviceType(deviceType);
    if (model !== undefined) {
      return model;
    } else {
      const typeDevice = getTypeFromDeviceType(deviceType);
      if (typeDevice !== undefined && deviceTypeIconMap[typeDevice] !== undefined) {
        return deviceTypeIconMap[typeDevice];
      }
    }
  }
  if (type !== undefined && deviceTypeIconMap[type] !== undefined) {
    return deviceTypeIconMap[type];
  }
  return UNKNOWN_DEVICE;
}

export function getModelFromDeviceType(type?: string): string | undefined {
  if (type === undefined) {
    return undefined;
  }

  if (specificDevices[type] !== undefined) {
    return specificDevices[type];
  }

  const genericType = type?.split('.').slice(0, 2).join('.');
  if (genericDevices[genericType] !== undefined) {
    return genericDevices[genericType];
  }

  return undefined;
}

export const devicesWithSvgIcon: { [key: string]: unknown } = {
  [DEVICE_TYPE.AXIS_THIRD_PARTY]: ThirdPartyAxisSIP,
};

const specificDevices: { [key: string]: string } = {
  '2.10.1.0': '2-10-0-0',
  '2.14.0.2': '2-14-0-0',
  '2.14.0.6': '2-14-0-0',
  '2.14.1.0': '2-14-1-0',
  '2.21.0.2': '2-21-0-0',
  '2.21.0.6': '2-21-0-0',
};

const genericDevices: { [key: string]: string } = {
  '2.0': '2-0-0-0',
  2.3: '2-3-0-0',
  2.5: '2-5-0-0',
  2.7: '2-7-0-0',
  2.9: '2-9-0-0',
  '2.10': '2-10-0-0',
  2.12: '2-12-0-0',
  2.14: '2-14-0-0',
  2.16: '2-16-0-0',
  2.18: '2-18-0-0',
  2.19: '2-19-0-0',
  2.21: '2-21-0-0',
  2.27: '2-27-0-0',
  2.28: '2-28-0-0',
  2.32: '2-32-0-0',
  2.33: '2-33-0-0',
  2.35: '2-35-0-0',
  2.37: '2-37-0-0',
  2.39: '2-39-0-0',
};

const deviceTypeIconMap: { [key: string]: string } = {
  [DEVICE_TYPE.HIPMO]: '1-1-0-0',
  [DEVICE_TYPE.IDT]: '3-1-0-0',
  [DEVICE_TYPE.THIRD_PARTY]: '1-2-0-0',
  [DEVICE_TYPE.DOOR_STATION]: '4-1-0-0',
  [DEVICE_TYPE.ID_TALK]: '2-25-0-0',
  [DEVICE_TYPE.CLIP]: '2-34-0-0',
  [DEVICE_TYPE.CHAMELEON]: '2-35-0-0',
  [DEVICE_TYPE.ID_COMPACT]: '2-26-0-0',
  [DEVICE_TYPE.ACCESS_UNIT]: '2-16-0-0',
  [DEVICE_TYPE.ACCESS_UNIT_M]: '2-16-0-0',
  [DEVICE_TYPE.ID_VIEW]: '2-30-0-0',
  [DEVICE_TYPE.IP_STYLE]: '2-31-0-0',
  [DEVICE_TYPE.IP_INTERCOM_V2]: '2-14-0-0',
  [DEVICE_TYPE.IP_ONE_INTERCOM]: '2-33-0-0',
};
